const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

const uploadFile = async ({ file, uri }: any) => {
  const response = await fetch(`${REACT_APP_API_URL}/${uri}`, {
    method: "PATCH",
    body: file,
  });
  if (response.status !== 200) {
    return Promise.reject("Something went wrong");
  }
  return response.json();
};

export default uploadFile;
